import { CM0061APIImpl } from "./ServiceImpl";

const CM0061Service = (api: CM0061APIImpl) => {
  return {};
};

export default CM0061Service;
